import { isNonNullable } from "../../../types/isNonNullable";

export const configComscoreAnalytics = (config) => {
  const videoLengthInMs = config.videoLengthInSec * 1000;
  const analytics = ns_.analytics;
  const analyticsConfig = new analytics.configuration.PublisherConfiguration({
    publisherId: "27061346",
    // demographics data defaults
    persistentLabels: {
      cs_fpid: null,
      cs_fpit: null,
      cs_fpdm: null,
      cs_fpdt: null,
    },
  });
  analytics.configuration.addClient(analyticsConfig);
  analytics.configuration.enableFirstPartyCookie();

  // UNCOMMENT FOR DEBUG MODE
  // TODO: comment out validation mode before releasing
  // analytics.configuration.enableImplementationValidationMode();

  analytics.start();

  const sa = new analytics.StreamingAnalytics();
  sa.setMediaPlayerName("web-videojs");

  const cm = new analytics.StreamingAnalytics.ContentMetadata();

  if (config.videoLengthInSec === 0) {
    cm.setMediaType(
      analytics.StreamingAnalytics.ContentMetadata.ContentType.LIVE,
    );
  } else {
    const VODContentType =
      config.videoLengthInSec < 600
        ? analytics.StreamingAnalytics.ContentMetadata.ContentType
            .SHORT_FORM_ON_DEMAND
        : analytics.StreamingAnalytics.ContentMetadata.ContentType
            .LONG_FORM_ON_DEMAND;
    cm.setMediaType(VODContentType);
  }

  cm.setUniqueId(config.contentId);
  cm.setLength(videoLengthInMs);
  cm.setPublisherName(config.publisherName);
  cm.setProgramTitle(config.programTitle);
  cm.setGenreName("Sports");
  cm.setDictionaryClassificationC6("Onefootball");

  sa.setMetadata(cm);

  sa.createPlaybackSession();
  return sa;
};

export const configureComscoreDemographics = ({
  cs_fpid,
  cs_fpit,
  cs_fpdm,
  cs_fpdt,
}) => {
  if (typeof ns_ === "undefined" || !ns_.analytics) {
    if (typeof window !== "undefined" && isNonNullable(window.COMSCORE)) {
      window.COMSCORE.beacon({
        c1: "2",
        c2: "27061346",
        cs_fpid: cs_fpid,
        cs_fpit: cs_fpit,
        cs_fpdm: cs_fpdm,
        cs_fpdt: cs_fpdt,
        options: {
          enableFirstPartyCookie: true,
        },
      });
    }
    return;
  }
  const analytics = ns_.analytics;
  analytics.configuration
    .getPublisherConfiguration("27061346")
    .setPersistentLabel("cs_fpid", cs_fpid);
  analytics.configuration
    .getPublisherConfiguration("27061346")
    .setPersistentLabel("cs_fpit", cs_fpit);
  analytics.configuration
    .getPublisherConfiguration("27061346")
    .setPersistentLabel("cs_fpdm", cs_fpdm);
  analytics.configuration
    .getPublisherConfiguration("27061346")
    .setPersistentLabel("cs_fpdt", cs_fpdt);
  analytics.notifyHiddenEvent();
};
